module.exports = __webpack_public_path__ + "img/expert_ruzhu.39319ee9.png";